import tagularModule from './../store/helpers/tagular'

const createFooterTrackingEvents = element => {
  const button = element.querySelector('[data-social-type]')

  button.addEventListener('click', function() {
    let socialMediaType = button.dataset.socialType

    const webElement = {
      location: 'Footer',
      position: 'footer',
      elementType: 'icon',
      text: socialMediaType,
      htmlId: 'social-share'
    }

    const actionOutcome = 'social sharing'
    const outboundUrl = ''
    const correlationId = ''

    tagularModule.elementClicked(
      webElement,
      actionOutcome,
      outboundUrl,
      correlationId,
      'redventures.usertracking.v3.ElementClicked'
    )

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      dL_navHeading: socialMediaType,
      dL_position: 'footer',
      event: 'e_navSocial'
    })
  })
}

const bindFooterTrackingEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createFooterTrackingEvents(element)
    })
  }
}

bindFooterTrackingEvents('[data-footer-social]')
